var _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.673617379884035e-18, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0h-16c-1.1,0 -1.99,0.9 -1.99,2l-0.01,18l4,-4h14c1.1,0 2,-0.9 2,-2v-12c0,-1.1 -0.9,-2 -2,-2zM7,9h-2v-2h2zM11,9h-2v-2h2zM15,9h-2v-2h2z",
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter"
    },
    vectorEffect: "non-scaling-stroke"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-16501425926886369",
    d: "M18,0h-16c-1.1,0 -1.99,0.9 -1.99,2l-0.01,18l4,-4h14c1.1,0 2,-0.9 2,-2v-12c0,-1.1 -0.9,-2 -2,-2zM7,9h-2v-2h2zM11,9h-2v-2h2zM15,9h-2v-2h2z",
    vectorEffect: "non-scaling-stroke"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.3a83d861.svg";
export { ForwardRef as ReactComponent };